<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Disciplines
              </div>
              <q-btn
                class="q-ml-md"
                color="primary"
                text-color="white"
                no-caps
                @click="newDialog = true"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="dataLoading"
                @click="loadData"
              >
              </q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="gridData">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 260px) !important"
                >
                  <datatable
                    :filter="search"
                    :flat="true"
                    :data="gridData"
                    :columns="columns"
                    @rowDoubleClick="handleDoubleClick"
                  >
                    <template
                      slot="body-cell-discipline_name"
                      slot-scope="data"
                    >
                      <q-td :props="data.props">
                        <div class="row items-center no-wrap">
                          <q-icon
                            v-if="data.props.row.parentDiscipline"
                            name="mdi-subdirectory-arrow-right"
                            size="sm"
                            color="grey-6"
                            class="q-mr-xs"
                          >
                            <q-tooltip
                              >Child of
                              {{
                                data.props.row.parentDisciplineName
                              }}</q-tooltip
                            >
                          </q-icon>
                          <div class="col">
                            {{ data.props.row.discipline_name }}
                            <q-chip
                              v-if="data.props.row.childCount > 0"
                              dense
                              color="primary"
                              text-color="white"
                              size="sm"
                              class="q-ml-sm"
                            >
                              {{ data.props.row.childCount }} child{{
                                data.props.row.childCount > 1 ? "ren" : ""
                              }}
                            </q-chip>
                          </div>
                        </div>
                      </q-td>
                    </template>
                    <template
                      slot="body-cell-parentDiscipline"
                      slot-scope="data"
                    >
                      <q-td :props="data.props">
                        <div class="row items-center">
                          <div class="col">
                            {{ data.props.row.parentDisciplineName || "None" }}
                          </div>
                          <div class="col-auto q-pl-sm">
                            <q-btn
                              @click.stop="openParentDisciplineMenu"
                              dense
                              round
                              flat
                              color="black"
                            >
                              <q-icon name="mdi-dots-vertical"></q-icon>
                              <q-menu>
                                <q-list style="min-width: 100px">
                                  <q-item
                                    v-if="data.props.row.childCount === 0"
                                    @click="
                                      parentDisciplineDialog = true;
                                      selectedDisciplineRow = data.props.row;
                                    "
                                    clickable
                                    v-close-popup
                                  >
                                    <q-item-section>
                                      {{
                                        data.props.row.parentDiscipline
                                          ? "Change Parent"
                                          : "Set Parent"
                                      }}
                                    </q-item-section>
                                  </q-item>
                                  <q-item
                                    v-if="data.props.row.parentDiscipline"
                                    @click="
                                      removeParentDiscipline(data.props.row)
                                    "
                                    clickable
                                    v-close-popup
                                  >
                                    <q-item-section
                                      >Remove Parent</q-item-section
                                    >
                                  </q-item>
                                  <q-item
                                    v-if="data.props.row.childCount > 0"
                                    @click="
                                      showChildDisciplines(data.props.row)
                                    "
                                    clickable
                                    v-close-popup
                                  >
                                    <q-item-section
                                      >Show Children</q-item-section
                                    >
                                  </q-item>
                                </q-list>
                              </q-menu>
                            </q-btn>
                          </div>
                        </div>
                      </q-td>
                    </template>
                    <template slot="body-cell-actions" slot-scope="data">
                      <q-td
                        :class="{
                          currentlyDeployedTD: data.props.value == 1,
                          notDeployedTD: data.props.value != 1
                        }"
                        :props="data.props"
                      >
                        <!-- <q-btn>Test</q-btn> -->
                        Coming soon!
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="newDialog" persistent max-width="600px">
      <q-card v-if="newDialog" tile style="width: 600px; max-width: 90vw">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Discipline</div>
            <q-space />
            <q-btn
              round
              flat
              icon="mdi-close"
              @click="
                newDialog = false;
                newFormData = {};
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-none">
          <competitionForm
            ref="newForm"
            @close="newDialog = false"
            @loadingStateChanged="state => (createLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.newForm.create()"
                :loading="createLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="viewDetailsDialog" persistent max-width="800px">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 800px; max-width: 90vw"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Discipline</div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="close"> </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-none">
          <competitionForm
            ref="editForm"
            :id="viewFormData.id"
            @close="close"
            @loadingStateChanged="state => (saveLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-content-save"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Save
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="parentDisciplineDialog" persistent max-width="600px">
      <q-card
        v-if="parentDisciplineDialog"
        tile
        style="width: 600px; max-width: 600px"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Parent Discipline
            </div>
            <q-space />
            <q-btn
              round
              flat
              icon="mdi-close"
              @click="parentDisciplineDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-md">
          <div class="row">
            <div class="col-12">
              <div class="text-h6 q-mb-md">
                Choose Parent Discipline for:
                {{ selectedDisciplineRow.discipline_name }}
              </div>
              <assignDiscipline
                class="full-width"
                dense
                label="Parent Discipline"
                :id="selectedDisciplineRow.parentDiscipline"
                :excludeIds="
                  selectedDisciplineRow ? [selectedDisciplineRow.id] : []
                "
                @changed="
                  val => {
                    if (selectedDisciplineRow) {
                      selectedDisciplineRow.parentDiscipline = val;
                      setParentDiscipline(selectedDisciplineRow);
                    }
                  }
                "
                clearable
              />
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="childDisciplinesDialog" persistent max-width="600px">
      <q-card
        v-if="childDisciplinesDialog"
        tile
        style="width: 600px; max-width: 600px"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Child Disciplines
            </div>
            <q-space />
            <q-btn
              round
              flat
              icon="mdi-close"
              @click="childDisciplinesDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-md">
          <div class="row">
            <div class="col-12">
              <div class="text-h6 q-mb-md">
                Children of: {{ selectedParentDiscipline.discipline_name }}
              </div>
              <div
                v-for="child in selectedParentDiscipline.childDisciplines"
                :key="child.id"
                class="q-mb-sm"
              >
                <q-card flat bordered>
                  <q-card-section class="q-pa-md">
                    <div class="row items-center">
                      <div class="col">
                        <strong>{{ child.discipline_name }}</strong>
                        <div class="text-caption">{{ child.description }}</div>
                      </div>
                      <div class="col-auto">
                        <q-btn
                          @click="
                            selectedDisciplineRow = child;
                            parentDisciplineDialog = true;
                            childDisciplinesDialog = false;
                          "
                          flat
                          color="primary"
                          label="Edit Parent"
                          size="sm"
                        />
                      </div>
                    </div>
                  </q-card-section>
                </q-card>
              </div>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import competitionForm from "@/components/disciplines/disciplineForm.vue";
import assignDiscipline from "@/components/disciplines/assignDiscipline.vue";

// import { Notify } from "quasar";

export default {
  components: {
    datatable,
    competitionForm,
    assignDiscipline
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      rawGridData: "disciplines/list",
      dataLoading: "disciplines/listLoading"
    }),
    gridData() {
      // Enrich the data with parent discipline names and child count
      if (!this.rawGridData) return [];

      const enrichedData = this.rawGridData.map(discipline => {
        const parentDiscipline = this.rawGridData.find(
          d => d.id === discipline.parentDiscipline
        );
        const childDisciplines = this.rawGridData.filter(
          d => d.parentDiscipline === discipline.id
        );
        return {
          ...discipline,
          parentDisciplineName: parentDiscipline
            ? parentDiscipline.discipline_name
            : null,
          childCount: childDisciplines.length,
          childDisciplines: childDisciplines
        };
      });

      // Create a hierarchical structure: parents followed immediately by their children
      const result = [];
      const processedIds = new Set();

      // First pass: add all parent disciplines (those without parents) and their children
      enrichedData
        .filter(d => !d.parentDiscipline)
        .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
        .forEach(parent => {
          // Add the parent
          result.push(parent);
          processedIds.add(parent.id);

          // Add its children immediately after
          enrichedData
            .filter(d => d.parentDiscipline === parent.id)
            .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
            .forEach(child => {
              result.push(child);
              processedIds.add(child.id);
            });
        });

      // Second pass: add any orphaned children (children whose parents aren't in the list)
      enrichedData
        .filter(d => d.parentDiscipline && !processedIds.has(d.id))
        .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
        .forEach(orphan => {
          result.push(orphan);
        });

      return result;
    }
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "discipline_name",
        label: "Discipline",
        align: "left",
        field: "discipline_name",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

        sortable: true
      },
      {
        name: "description",
        label: "Description",
        align: "left",
        field: "description",
        sortable: true
      },
      {
        name: "teamSize",
        label: "Team Size",
        align: "left",
        field: row => row,
        format: val => {
          let playerLabels = JSON.parse(val.playerLabels);
          let maxTeamSize = playerLabels.length;
          let minTeamSize = playerLabels.filter(pl => pl.required == 1).length;
          return `${minTeamSize}-${maxTeamSize}`;
        },
        sortable: true
      },
      {
        name: "type",
        label: "Sport Type",
        align: "left",
        field: "type",
        sortable: true
      },
      {
        name: "parentDiscipline",
        label: "Parent Discipline",
        align: "left",
        field: "parentDisciplineName",
        style:
          "min-width: 200px;max-width: 200px;width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      }
    ],
    search: "",

    createLoading: false,

    newDialog: false,

    // View and Edit
    viewFormData: {},
    saveLoading: false,
    viewDetailsDialog: false,

    // Parent Discipline
    parentDisciplineDialog: false,
    selectedDisciplineRow: null,

    // Child Disciplines
    childDisciplinesDialog: false,
    selectedParentDiscipline: null
  }),
  watch: {
    $route: function() {
      this.handleRoute();
    }
  },
  mounted() {
    this.loadData();
    this.handleRoute();
  },
  methods: {
    handleDoubleClick(row) {
      this.$router.push(`${this.$route.path}/${row.id}`);
    },
    loadData() {
      this.$store.dispatch("disciplines/loadAll");
    },
    handleRoute() {
      if (this.$route.params.id) {
        this.viewFormData = { id: this.$route.params.id };
        this.$nextTick(() => {
          this.viewDetailsDialog = true;
        });
      } else {
        this.viewDetailsDialog = false;
      }
    },
    close() {
      this.$router.push("/management/disciplines");
    },
    setParentDiscipline(row) {
      let payload = {
        id: row.id,
        parentDiscipline: row.parentDiscipline
      };

      this.$store
        .dispatch("disciplines/setParentDiscipline", payload)
        .then(result => {
          this.loadData();
          this.parentDisciplineDialog = false;
          this.selectedDisciplineRow = null;
          this.$q.notify({
            position: "top-right",
            type: result.Result == "Success" ? "positive" : "negative",
            message:
              result.Response?.Message ||
              (result.Result == "Success"
                ? "Parent discipline updated successfully"
                : "There was an error updating the parent discipline")
          });
        });
    },
    removeParentDiscipline(row) {
      let payload = {
        id: row.id,
        parentDiscipline: null
      };

      this.$store
        .dispatch("disciplines/setParentDiscipline", payload)
        .then(result => {
          this.loadData();
          this.$q.notify({
            position: "top-right",
            type: result.Result == "Success" ? "positive" : "negative",
            message:
              result.Response?.Message ||
              (result.Result == "Success"
                ? "Parent discipline removed successfully"
                : "There was an error removing the parent discipline")
          });
        });
    },
    openParentDisciplineMenu() {
      // This method is just a placeholder for the click event
    },
    showChildDisciplines(row) {
      this.selectedParentDiscipline = row;
      this.childDisciplinesDialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}

.formHeight {
  min-height: calc(100vh - 175px);
  max-height: 1000px;
}
</style>
